/* eslint-disable */
import React, { useState, useLayoutEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Img from 'gatsby-image';
import { gsap } from 'gsap';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { filterNewsByCategory, filterNewsByTopic } from '../../actions/news-filter-actions';
import Container from '../Container';
import { useCreateSourceHeaderImage } from '../../hooks/archive-hooks';
import Icon from '../Icons';
import TransitionLink from '../TransitionLink';

const HeaderSingleNews = ({
  coverImage,
  coverImageMobile,
  categoryNews,
  topic,
  title,
  time,
  dispatchFilterNewsByCategory,
  dispatchFilterNewsByTopic,
  label,
  archiveUrl
}) => {
  const [isActive, setIsActive] = useState(false);
  const classNameContainer = `${coverImage ? 'header-single-news--with-image' : 'header-single-news--only-color'}`;
  const maskRef = useRef(null);
  const sectionRef = useRef(null);
  const handleNavigate = () => {
    if (categoryNews) {
      const formattedCategory = {
        value: categoryNews.slug,
        label: categoryNews.name
      };

      const formattedTopic = {
        value: topic.slug,
        label: topic.name
      };

      dispatchFilterNewsByCategory(formattedCategory);
      dispatchFilterNewsByTopic(formattedTopic);
      const anchor = document.getElementsByClassName('header-single-news__archive-link');
      anchor[0].click();
    }
  };

  gsap.registerPlugin(CSSRulePlugin);
  gsap.registerPlugin(ScrollTrigger);

  const animationHeaderNews = () => {
    if (typeof window !== 'undefined' && maskRef !== null && sectionRef !== null) {
      const tl = gsap.timeline();
      tl.to(
        maskRef.current,
        { opacity: 0, duration: 1.5 }
      );
      tl.fromTo(
        '.header-single-news__image',
        { scale: 1.3 },
        { scale: 1, duration: 1.5 }, 0
      );

      ScrollTrigger.matchMedia({
        '(min-width: 768px) and (max-width: 1023px)': () => {
          tl.fromTo('.header-single-news__image',
            { scale: 1 },
            {
              scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 78px',
                scrub: true,
              },
              scale: 1.3,
              ease: 'none'
            }
          );
          tl.fromTo(maskRef.current, { opacity: 0 }, {
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 78px',
              scrub: true,
            },
            opacity: 1,
            ease: 'none'
          });
          ScrollTrigger.create({
            trigger: sectionRef.current,
            start: 'top 78px',
            pin: '.header-single-news__image-container',
          });
        },
        '(min-width: 1024px) and (max-width: 1365px)': () => {
          tl.fromTo('.header-single-news__image',
            { scale: 1 },
            {
              scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 110px',
                scrub: true,
              },
              scale: 1.3,
              ease: 'none'
            }
          );
          tl.fromTo(maskRef.current, { opacity: 0 }, {
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 110px',
              scrub: true,
            },
            opacity: 1,
            ease: 'none'
          });
          ScrollTrigger.create({
            trigger: sectionRef.current,
            start: 'top 110px',
            pin: '.header-single-news__image-container',
          });
        },
        '(min-width: 1366px)': () => {
          tl.fromTo('.header-single-news__image',
            { scale: 1 },
            {
              scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top top',
                scrub: true,
              },
              scale: 1.3,
              ease: 'none'
            }
          );
          tl.fromTo(maskRef.current, { opacity: 0 }, {
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top top',
              scrub: true,
            },
            opacity: 1,
            ease: 'none'
          });
          ScrollTrigger.create({
            trigger: sectionRef.current,
            start: 'top top',
            pin: '.header-single-news__image-container',
          });
        },
        '(max-width: 767px)': () => {
          tl.fromTo('.header-single-news__image',
            { scale: 1 },
            {
              scrollTrigger: {
                trigger: sectionRef.current,
                start: 'top 60px',
                scrub: true,
              },
              scale: 1.3,
              ease: 'none'
            }
          );
          tl.fromTo(maskRef.current, { opacity: 0 }, {
            scrollTrigger: {
              trigger: sectionRef.current,
              start: 'top 60px',
              scrub: true,
            },
            opacity: 1,
            ease: 'none'
          });
          ScrollTrigger.create({
            trigger: sectionRef.current,
            start: 'top 60px',
            pin: '.header-single-news__image-container',
          });
        },
      });
    }
  };

  useLayoutEffect(() => {
    setTimeout(() => {
      setIsActive(true);
    }, 100);
    animationHeaderNews();
  }, []);

  return (
    <Container refProps={sectionRef} className={`header-single-news ${isActive ? 'header-single-news--active' : ''}`}>
      <div className={classNameContainer}>
        { coverImage && <div ref={maskRef} className="header-single-news__mask" /> }
        { coverImage && (
          <div className="header-single-news__image-container">
            <Img
              fluid={useCreateSourceHeaderImage(coverImage, coverImageMobile)}
              className="header-single-news__image"
              alt={coverImage.alt}
            />
          </div>
        ) }
      </div>
      <div className="header-single-news__title-wrapper">
        <div className="text-news">
          <div className="text-news__content">
            {
              topic ? (
                  <button
                    className="text-news__label label-small"
                    type="button"
                    onClick={() => handleNavigate()}
                  >
                    {topic.name}
                  </button>
                )
                : (
                  <TransitionLink to={`${archiveUrl}/`} className="text-news__label label-small">
                    {label}
                  </TransitionLink>
                )
            }
            {title && <h1 className="text-news__title heading-lg">{title}</h1>}
            {
              time && (
                <p className="text-news__time">
                  <Icon className="text-news__icon icon--24" path="access-time" />
                  <span className="text-news__timing paragraph-small">{time} {time > 1 ? 'minuti' : 'minuto'} di lettura</span>
                </p>
              )
            }
          </div>
        </div>
      </div>
      <TransitionLink className="header-single-news__archive-link" to="/media/" />
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchFilterNewsByCategory: (category) => dispatch(filterNewsByCategory(category)),
    dispatchFilterNewsByTopic: (topic) => dispatch(filterNewsByTopic(topic))
  };
};

export default connect(null, mapDispatchToProps)(HeaderSingleNews);
